

















import Vue from 'vue'

export default Vue.component('announcement', {
  props: {
    event: Object
  },
  computed: {
    typeClass: function () {
      const obj: any = {}
      obj[`type-${this.event.id}`] = true
      return obj
    }
  },
  methods: {
    acceptEvent: function () {
      this.$emit('accept-event')
    },
    rejectEvent: function () {
      this.$emit('reject-event')
    }
  }
})
